import moment from 'moment-timezone';
import qs from 'qs';
import {
  PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST,
  PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE,
  PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectUnitLayoutSpecificationsRequest() {
  return {
    type: PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST,
  };
}

function projectUnitLayoutSpecificationsSuccess(data, token = null) {
  return {
    type: PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectUnitLayoutSpecificationsError(message) {
  return {
    type: PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectUnitLayoutSpecifications(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectUnitLayoutSpecificationsRequest());
    if (!fresh) {
      let projectUnitLayoutSpecificationsData = {};
      try {
        projectUnitLayoutSpecificationsData = JSON.parse(getItem(`${config.get('appName')}.projectUnitLayoutSpecifications`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectUnitLayoutSpecificationsData.data ||
        config.get('version') !== projectUnitLayoutSpecificationsData.version ||
        moment().isAfter(moment(projectUnitLayoutSpecificationsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectUnitLayoutSpecificationsSuccess(projectUnitLayoutSpecificationsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/specifications/unit_layouts/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectUnitLayoutSpecifications`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectUnitLayoutSpecificationsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectUnitLayoutSpecificationsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectUnitLayoutSpecifications.js